<template>
	<v-container fluid>
		<Payment
			:id="paymentModal.id"
			:invoice="paymentModal.invoice_id"
			:show="paymentModal.show"
			@callback="paymentModalCallback"
		/>
		<v-layout row wrap>
			<v-flex xs12>
				<v-btn class="ml-0" color="success" @click="addClick">
					<v-icon small>fa-plus</v-icon>&nbsp;&nbsp;{{
						$t("buttons.addInvoice")
					}}
				</v-btn>
				<v-btn
					v-if="markedRecords.length != 0"
					class="ml-0"
					color="success"
					@click="markAsPaidClick"
				>
					<v-icon small>fa-dollar-sign</v-icon>&nbsp;&nbsp;{{
						$t("buttons.markAsPaid")
					}}
				</v-btn>
			</v-flex>
		</v-layout>
		<v-layout row wrap>
			<v-flex xs12>
				<v-card class="elevation-0 background-transparent">
					<DataTable
						:excel="true"
						:additional-filters="invoicesTable.additionalFilters"
						:headers="invoicesTable.headers"
						:items="invoicesTable.items"
						:total="invoicesTable.total"
						@excel="excelExport"
						@reload="reloadData"
					>
						<template #row="props">
							<tr
								:key="props.item.id"
								:class="{
									'cursor-pointer': true,
									'cancelled-row':
										props.item.cancelled_by != null,
									'cancels-row': props.item.cancels !== null
								}"
								@contextmenu.prevent="
									editClick(props.item.id, true)
								"
							>
								<td>
									<v-checkbox
										v-model="markedRecords"
										:value="props.item.id"
										hide-details
									></v-checkbox>
								</td>
								<td>
									<v-tooltip
										bottom
										v-if="props.item.cancelled_by == true"
									>
										<template
											v-slot:activator="{ on, attrs }"
										>
											<v-chip
												v-bind="attrs"
												v-on="on"
												class="text-uppercase font-weight-bold"
												text-color="#ff0000"
												color="#ffffff"
											>
												S
											</v-chip>
										</template>
										<span>
											{{ props.item.cancelled_by }}
										</span>
									</v-tooltip>
									<v-tooltip
										bottom
										v-if="props.item.cancels != null"
									>
										<template
											v-slot:activator="{ on, attrs }"
										>
											<v-chip
												v-bind="attrs"
												v-on="on"
												class="text-uppercase font-weight-bold"
												text-color="#ff0000"
												color="#ffffff"
												>S</v-chip
											>
										</template>
										<span>{{ props.item.cancels }}</span>
									</v-tooltip>
								</td>
								<td @click="editClick(props.item.id, false)">
									{{ props.item.id }}
								</td>
								<td @click="editClick(props.item.id, false)">
									{{ props.item.number }}
								</td>
								<td @click="editClick(props.item.id, false)">
									{{ props.item.time_of_issue_display }}
								</td>
								<td @click="editClick(props.item.id, false)">
									{{ props.item.payment_account_display }}
								</td>
								<td @click="editClick(props.item.id, false)">
									{{ props.item.tour_id }}
								</td>
								<td @click="editClick(props.item.id, false)">
									{{ props.item.subject_display }}
								</td>
								<td @click="editClick(props.item.id, false)">
									{{ props.item.due_date_display }}
								</td>
								<td
									class="text-xs-right"
									@click="editClick(props.item.id, false)"
								>
									{{ props.item.amount_display }}
								</td>
								<td
									class="text-xs-right"
									@click="editClick(props.item.id, false)"
								>
									{{ props.item.paid_amount_display }}
								</td>
								<td>
									<v-tooltip bottom>
										<v-btn
											slot="activator"
											icon
											@click="pdfClick(props.item.id)"
										>
											<v-icon small>fa-file-pdf</v-icon>
										</v-btn>
										<span>{{ $t("tooltips.pdf") }}</span>
									</v-tooltip>
									<v-tooltip
										v-if="props.item.deletable"
										bottom
									>
										<v-btn
											slot="activator"
											icon
											@click="deleteClick(props.item.id)"
										>
											<v-icon small>fa-trash</v-icon>
										</v-btn>
										<span>{{
											$t("tooltips.deleteInvoice")
										}}</span>
									</v-tooltip>
									<v-tooltip
										v-if="
											props.item.cancels == null &&
												props.item.total_paid <
													props.item.amount
										"
										bottom
									>
										<v-btn
											slot="activator"
											icon
											@click="
												addPaymentClick(props.item.id)
											"
										>
											<v-icon small
												>fa-money-bill-alt</v-icon
											>
										</v-btn>
										<span>{{
											$t("tooltips.recordPayment")
										}}</span>
									</v-tooltip>
									<v-tooltip bottom>
										<v-btn
											slot="activator"
											icon
											@click="
												editClick(props.item.id, true)
											"
										>
											<v-icon small
												>fa-external-link-alt</v-icon
											>
										</v-btn>
										<span>{{
											$t("tooltips.openInNewTab")
										}}</span>
									</v-tooltip>
								</td>
							</tr>
						</template>
					</DataTable>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import DataTable from "./trinkets/DataTable";
import Payment from "./modals/Payment";

export default {
	name: "Invoices",
	components: { DataTable, Payment },
	data: function() {
		return {
			invoicesTable: {
				headers: [
					{
						text: "",
						value: "selection",
						type: "",
						sortable: false,
						align: "left",
						width: "30px",
						searchable: false
					},
					{
						text: "",
						value: "cancelled",
						type: "",
						sortable: false,
						align: "center",
						searchable: false,
						width: "30px"
					},
					{
						text: this.$t("fields.id"),
						value: "id",
						type: "string",
						searchable: false
					},
					{
						text: this.$t("fields.invoiceNumber"),
						value: "number",
						type: "string",
						searchable: "hidden"
					},
					{
						text: this.$t("fields.invoiceDate"),
						value: "time_of_issue",
						type: "date_range",
						searchable: "hidden"
					},
					{
						text: this.$t("fields.account"),
						value: "payment_account_id",
						type: "dropdown|payment-accounts",
						searchable: "hidden"
					},
					{
						text: this.$t("fields.tourId"),
						value: "tour_id",
						type: "dropdown|tours",
						searchable: "hidden"
					},
					{
						text: this.$t("fields.buyerName"),
						value: "subject_id",
						type: "dropdown|subjects-buyers",
						searchable: "hidden"
					},
					{
						text: this.$t("fields.dueDate"),
						value: "due_date",
						type: "date_range",
						searchable: "hidden"
					},
					{
						text: this.$t("fields.totalAmount"),
						value: "amount",
						type: "price_range",
						searchable: "hidden",
						class: "text-xs-right"
					},
					{
						text: this.$t("fields.paidAmount"),
						value: "paid_amount",
						type: "price_range",
						searchable: "hidden",
						class: "text-xs-right"
					},
					{
						text: "",
						value: "actions",
						type: "",
						sortable: false,
						align: "right",
						width: "260px",
						searchable: false
					}
				],
				additionalFilters: [
					{
						text: this.$t("fields.fullyPaid"),
						value: "fully_paid",
						type: "boolean",
						searchable: "hidden"
					}
				],
				items: [],
				total: 0,
				lastRequest: null
			},
			paymentModal: {
				show: false,
				id: null,
				invoice_id: null
			},
			markedRecords: []
		};
	},
	methods: {
		markAsPaidClick() {
			let vm = this;
			this.$verify(
				this.$t("alerts.markAsPaidQuestionMultiple"),
				result => {
					if (result) {
						vm.$APICall(
							"post",
							"invoices/mark-as-paid",
							{ records: this.markedRecords },
							(data, success) => {
								if (success) {
									vm.markedRecords = [];
									vm.reloadData(vm.invoicesTable.lastRequest);
								} else {
									vm.$alert(vm.$t("alerts.basicError"));
								}
							}
						);
					}
				}
			);
		},
		pdfClick(invoiceId) {
			let vm = this;
			vm.$APICall(
				"get",
				"invoices/" + invoiceId + "/pdf",
				{},
				(data, success) => {
					if (success) {
						window.open(data.pdf_link);
					} else {
						vm.$alert(vm.$t("alerts.basicError"));
					}
				}
			);
		},
		deleteClick(invoiceId) {
			let vm = this;
			this.$verify(this.$t("alerts.deletionQuestion"), result => {
				if (result) {
					vm.$APICall(
						"delete",
						"invoices/" + invoiceId,
						{},
						(data, success) => {
							if (success) {
								vm.reloadData(vm.invoicesTable.lastRequest);
							} else {
								vm.$alert(vm.$t("alerts.basicError"));
							}
						}
					);
				}
			});
		},
		addPaymentClick(invoiceId) {
			this.paymentModal.invoice_id = invoiceId;
			this.paymentModal.show = true;
		},
		paymentModalCallback() {
			this.paymentModal.show = false;
		},
		addClick() {
			this.$router.push("/invoices/0/new");
		},
		editClick(id, newTab = false) {
			if (!newTab) {
				this.$router.push("/invoices/" + id + "/edit");
			} else {
				let routeData = this.$router.resolve(
					"/invoices/" + id + "/edit"
				);
				window.open(routeData.href, "_blank");
			}
		},
		reloadData(request) {
			this.invoicesTable.lastRequest = request;
			let vm = this;
			this.$APICall(
				"get",
				"invoices",
				request,
				(data, success) => {
					if (success) {
						vm.markedRecords = [];
						vm.invoicesTable.items = data.items;
						vm.invoicesTable.total = data.total;
					} else {
						vm.$alert(vm.$t("alerts.basicError"));
					}
				},
				false
			);
		},
		excelExport() {
			let excelRequest = JSON.parse(
				JSON.stringify(this.invoicesTable.lastRequest)
			);
			excelRequest.pagination.rowsPerPage = 999999999;
			excelRequest.pagination.page = 1;

			let vm = this;
			this.$APICall(
				"get",
				"invoices",
				excelRequest,
				(data, success) => {
					if (success) {
						vm.$APICall(
							"post",
							"excel/invoices",
							data.items,
							(data, success) => {
								window.open(data.link);
							}
						);
					} else {
						vm.$alert(vm.$t("alerts.basicError"));
					}
				},
				false
			);
		}
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace("login");
		}
		this.$setSubMenu("Finance");
		this.$myStore.commit("setBreadcrumbs", [
			{
				text: this.$t("modules.invoices"),
				href: "/#/invoices",
				disabled: true
			}
		]);
	}
};
</script>

<style scoped>
.cancelled-row {
	color: rgb(0, 114, 188);
}
.cancels-row {
	color: rgb(153, 57, 33);
}
</style>
